module.exports = __webpack_public_path__ + "img/pdf-pink-used.c0cb282e.svg";